export enum Tabs {
  Feeds = 'feeds',
  Schedules = 'schedules',
}

export const FEEDS_TAB = Tabs.Feeds
export const SCHEDULES_TAB = Tabs.Schedules

const TABS = [
  {
    id: FEEDS_TAB,
    name: 'main.header.feeds',
    isActive: true,
  },
  {
    id: SCHEDULES_TAB,
    name: 'main.header.schedules',
    isActive: false,
  },
]

const STEPPER = [
  {
    id: 0,
    title: 'Source',
    status: 'active',
  },
  {
    id: 1,
    title: 'Parameters',
    status: 'incomplete',
  },
  {
    id: 2,
    title: 'Format',
    status: 'incomplete',
  },
  {
    id: 3,
    title: 'Delivery',
    status: 'incomplete',
  },
]

export { TABS, STEPPER }
